/** "gateCode" → "Gate Code", for friendlier display-name placeholders and labels. */
export const titleCase = (value: string): string =>
  value
    .replace(/([A-Z])/g, ' $1')
    .replace(/[_-]+/g, ' ')
    .replace(/^./, char => char.toUpperCase())
    .replace(/\s+/g, ' ')
    .trim();
